import { useEffect } from "react";
import { getSiteLogoUrl, getSiteUrl } from "../utils/siteUrl";

const SITE_TITLE = "Zaror Sports - Custom Teamwear & Kit Designer";
const SITE_DESCRIPTION =
  "Zaror Sports - Custom teamwear and kit designer. Design your own football, basketball, cricket, and hockey kits with professional colour options and customization.";

function setMetaTag(attribute, key, content) {
  if (!content) return;

  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

const SocialMetaUpdater = () => {
  useEffect(() => {
    const siteUrl = getSiteUrl();
    const logoUrl = getSiteLogoUrl();

    document.title = SITE_TITLE;
    setMetaTag("name", "description", SITE_DESCRIPTION);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:site_name", "Zaror Sports");
    setMetaTag("property", "og:title", SITE_TITLE);
    setMetaTag("property", "og:description", SITE_DESCRIPTION);
    setMetaTag("property", "og:url", `${siteUrl}/`);
    setMetaTag("property", "og:image", logoUrl);
    setMetaTag("property", "og:image:alt", "Zaror Sports logo");
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", SITE_TITLE);
    setMetaTag("name", "twitter:description", SITE_DESCRIPTION);
    setMetaTag("name", "twitter:image", logoUrl);
  }, []);

  return null;
};

export default SocialMetaUpdater;
